import React, {useEffect, useState} from 'react';
import SoapResponse from '../SoapResponse.js';
import { properties } from '../../properties';
import ErrorPage from '../../ErrorPage.js';
import LoaderComp from '../LoaderComp.js';
import transidgenerator from '../../transidgenerator.js';
import $ from "jquery";

function SoapTokenAuthSettle({ apiUrl }) {
    const [soapTokenAuthSettle, setSoapTokenAuthSettle] = useState({
        operation: properties.OPERATIONS.tokenAuthSettle,
        vendorid: properties.VENDOR_ID,
        userid: properties.USER_ID,
        transactionid: transidgenerator(),
        method: properties.SOAP_METHOD,
        customerPresent: properties.CUSTOMER_PRESENT,
        token: properties.TOKEN,
        description: properties.DESCRIPTION,
        value: properties.VALUE,
        currency: properties.CURRENCY,
        timestamp: "",
        region: properties.SEL_REGION,
        postCode: properties.POST_CODE,
        address: properties.ADDRESS,
        countryCode: properties.COUNTRY_CODE,
        allowCscFail: properties.ALLOW_CSC_FAIL,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        password: properties.PASSWORD,
        security: ""
    });
 
    var canSubmit = true;
 
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    const [response, setResponse] = useState();

    function changeTransactionId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, transactionid: e.target.value });
    }

    function changeUserId(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, userid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, password: e.target.value });
    }

    function changeMethod(e) {
        isNotNullCheck(e.target.value,"WPG_method");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, method: e.target.value });
    }

    function changeDesc(e) {
        isNotNullCheck(e.target.value,"WPG_description");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, description: e.target.value });
    }

    function changeValue(e) {
        isNotNullCheck(e.target.value,"WPG_value");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, value: e.target.value });
    }

    function changeCurrency(e) {
        isNotNullCheck(e.target.value,"WPG_currency");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, currency: e.target.value });
    }

    function changeToken(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, token: e.target.value });
    }

    function changeAddr(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, address: e.target.value });
    }

    function changePostCode(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, allowAvsFail: e.target.value });
    }

    function changeAllowCscFail(e) {
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, allowCscFail: e.target.value });
    }

    function changeCustPresent(e) {
        isNotNullCheck(e.target.value,"WPG_customerPresent");
        setSoapTokenAuthSettle({ ...soapTokenAuthSettle, customerPresent: e.target.value });
    }
    var region =[];
 
    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    async function onSubmitTokenAuthSet(e) {
        e.preventDefault();
        isNotNullCheck(soapTokenAuthSettle.transactionid,"WPG_transID");
        isNotNullCheck(soapTokenAuthSettle.vendorid,"WPG_vendorID");
        isNotNullCheck(soapTokenAuthSettle.password,"vendorPwd");
        isNotNullCheck(soapTokenAuthSettle.description,"WPG_description");
        isNotNullCheck(soapTokenAuthSettle.method,"WPG_method");
        isNotNullCheck(soapTokenAuthSettle.customerPresent,"WPG_customerPresent");
        isNotNullCheck(soapTokenAuthSettle.value,"WPG_value");
        isNotNullCheck(soapTokenAuthSettle.region,"WPG_region");
        isNotNullCheck(soapTokenAuthSettle.token,"WPG_token");
        isNotNullCheck(soapTokenAuthSettle.currency,"WPG_currency");
        soapTokenAuthSettle.timestamp = Math.floor(Date.now() / 1000);
        var md5 = require('md5');
        const requestbody =
        {
            vendorID: soapTokenAuthSettle.vendorid,
            transID: soapTokenAuthSettle.transactionid,
            userID: soapTokenAuthSettle.userid,
            method: soapTokenAuthSettle.method,
            customerPresent: soapTokenAuthSettle.customerPresent,
            token: soapTokenAuthSettle.token,
            description: soapTokenAuthSettle.description,
            value: soapTokenAuthSettle.value,
            currency: soapTokenAuthSettle.currency,
            timestamp: soapTokenAuthSettle.timestamp,
            region: soapTokenAuthSettle.region,
            AVSAddr: soapTokenAuthSettle.address,
            AVSPost: soapTokenAuthSettle.postCode,
            countryCode: soapTokenAuthSettle.countryCode,
            allowCSCFail: soapTokenAuthSettle.allowCscFail,
            allowAVSFail: soapTokenAuthSettle.allowAvsFail,
            security: md5(soapTokenAuthSettle.vendorid +
                soapTokenAuthSettle.transactionid + soapTokenAuthSettle.userid +
                soapTokenAuthSettle.method + soapTokenAuthSettle.customerPresent +
                soapTokenAuthSettle.token + soapTokenAuthSettle.description +
                soapTokenAuthSettle.value + soapTokenAuthSettle.currency +
                soapTokenAuthSettle.timestamp + soapTokenAuthSettle.region + 
                soapTokenAuthSettle.address + soapTokenAuthSettle.postCode +
                soapTokenAuthSettle.countryCode + soapTokenAuthSettle.allowCscFail +
                soapTokenAuthSettle.allowAvsFail + soapTokenAuthSettle.password),
        };
        var xmlBody = [];
        xmlBody.push(properties.SOAP_REQUEST_PREFIX + "<ns1:tokenAuthoriseSettle>" );
        for (var property in requestbody) {
            xmlBody.push("<" + property + ">" + requestbody[property] + "</" + property + ">");
        }
        xmlBody.push("</ns1:tokenAuthoriseSettle>" + properties.SOAP_REQUEST_SUFFIX);
        xmlBody = xmlBody.join("\n");
        var request = {
            method: 'POST',
            headers: new Headers({
                'Accept-Type': 'text/xml',
                'Content-Type': 'text/xml'
            }),
            body: xmlBody
        };
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            var statusCode;
            if(soapTokenAuthSettle.region === "NoR"){
                setSoapTokenAuthSettle({...soapTokenAuthSettle, region:""});
            }
            fetch(apiUrl, request)
            .then(resp => {
                if(Object.keys(properties.RESPONSE_STATUS_MESSAGE).indexOf(String(resp.status)) === -1){
                    return resp.text();
                }
                else{
                    statusCode = resp.status;
                    throw resp;
                }
            })
            .then(responsedata => setResponse(<SoapResponse title="Token Authorise & Settle Response" operation="WPG_tokenauthsettle" message={responsedata} />))
            .catch((error)=>{
                console.log(error);
                setResponse(<ErrorPage code={statusCode} />);
            });
        }
    }  
       
    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);

    var tokenAuthSettleTemplate = (
        <div className="operation-form">
            <h2>Token Authorise & Settle</h2>
            <form className="form-horizontal" method='post' onSubmit={onSubmitTokenAuthSet}>
                <div className="form-group">
                    <div className="control-label">
                        Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_vendorID" value={soapTokenAuthSettle.vendorid} onChange={changeVendorId} />
                        <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_transID" value={soapTokenAuthSettle.transactionid} onChange={changeTransactionId} />
                        <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        User ID
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_userid" value={soapTokenAuthSettle.userid} onChange={changeUserId} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Method<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_method" value={soapTokenAuthSettle.method} onChange={changeMethod} />
                        <div className="error-msg" name="WPG_method">Method is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Present<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_customerPresent" value={soapTokenAuthSettle.customerPresent} onChange={changeCustPresent}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                        <div className="error-msg" name="WPG_customerPresent">Customer Present is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_description" value={soapTokenAuthSettle.description} onChange={changeDesc} />
                        <div className="error-msg" name="WPG_description">Description is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Value<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_value" value={soapTokenAuthSettle.value} onChange={changeValue} />
                        <div className="error-msg" name="WPG_value">Value is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Currency Code<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_currency" value={soapTokenAuthSettle.currency} onChange={changeCurrency} />
                        <div className="error-msg" name="WPG_currency">ISO Currency Code is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" value={soapTokenAuthSettle.region} onChange={changeRegion}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Token<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_token" value={soapTokenAuthSettle.token} onChange={changeToken} />
                        <div className="error-msg" name="WPG_token">Token is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        AVS Address
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" value={soapTokenAuthSettle.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        AVS Post Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" value={soapTokenAuthSettle.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" value={soapTokenAuthSettle.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow CSC Failure
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" value={soapTokenAuthSettle.allowCscFail} onChange={changeAllowCscFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Failure
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" value={soapTokenAuthSettle.allowAvsFail} onChange={changeAllowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={soapTokenAuthSettle.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary">Perform</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return response ? response : tokenAuthSettleTemplate;
}

export default SoapTokenAuthSettle;